import React, { useState, useEffect } from "react";
import api from "../../services/api";
import {useLocation, useNavigate} from "react-router-dom";
import BreadCrumbDiv from "../../components/common/BreadCrumbDiv";
import TextBoxArea from "../../components/common/TextBoxArea";
import SearchInput from "../../components/common/SearchInput";
import FunctionButton from "../../components/common/FunctionButton";
import ButtonWrapDiv from "../../components/common/ButtonWrapDiv";
import { useTranslation } from "react-i18next";
import LoginInputWrapDiv from "../../components/common/LoginInputWrapDiv";
import LoginButton from "../../components/common/LoginButton";
import MessageDialog from "../../components/common/MessageDialog";

const RegWaCheckPage = () => {
  const navigate = useNavigate();
  const rLocation = useLocation();
  const { t } = useTranslation();

  const [id, setId] = useState("");
  const [pwd, setPwd] = useState("");
  const [confirm, setConfirm] = useState(false);

  const [dialogMsg, setDialogMsg] = useState("");
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const united = rLocation.state?.united || null;
  const country = rLocation.state?.country || null;
  const location = rLocation.state?.location || null;
  const loc = rLocation.state?.loc || null;

  useEffect(() => {
    if (!united || !location || !loc || !country) {
      navigate("/login");
    }
  });

  const handleIdChange = (e) => {
    setId(e.target.value.trim());
    setConfirm(false);
  };

  const handlePwdChange = (e) => {
    setPwd(e.target.value.trim());
    setConfirm(false);
  };

  const submitWaAccount = () => {
    if (!id) {
      setDialogMsg(t("L1086"));
      setIsDialogOpen(true);
      return;
    }

    api
      .post("/user/wacheck", {
        loc: loc,
        waUserId: id,
        waPwd: pwd
      })
      .then((response) => {
        if (!response.data) {
          setDialogMsg(t("L1088"));
          setIsDialogOpen(true);
        } else {
          setDialogMsg(t("L1087"));
          setIsDialogOpen(true);
          setConfirm(true);
        }
      })
      .catch(() => {});
  };

  const handleConfirm = () => {
    setDialogMsg("");
    setIsDialogOpen(false);
  };

  const handleNext = () => {
    if (!confirm) {
      setDialogMsg(t("L1086"));
      setIsDialogOpen(true);
      return;
    }

    navigate("/join/reg-agreement", {
      state: {
        united: united,
        country: country,
        location: location,
        loc: loc,
        waUserId: id,
        waPwd: pwd
      },
    });
  };

  if (!united || !location || !loc || !country) {
    navigate("/login");
  }

  return (
    <div>
      <BreadCrumbDiv items={[t("L0341"), t("L0342")]}></BreadCrumbDiv>
      <TextBoxArea className={"ptb100"}>
        <h2>{t("L1086")}</h2>

        <LoginInputWrapDiv>
          <ul>
            <li>
              <SearchInput
                width="370px"
                value={id}
                onChange={handleIdChange}
                placeholder={`WA ${t("L0002")}`}
                maxLength={200}
                style={{
                  height: "50px",
                  fontSize: "15px",
                }}
              ></SearchInput>
            </li>

            <li>
              <SearchInput
                  type="password"
                  width="370px"
                  value={pwd}
                  onChange={handlePwdChange}
                  placeholder={`WA ${t("L0027")}`}
                  maxLength={200}
                  style={{
                    height: "50px",
                    fontSize: "15px",
                    paddingLeft: "10px",
                  }}
              ></SearchInput>
            </li>
          </ul>
          <LoginButton onClick={submitWaAccount}>Submit</LoginButton>
        </LoginInputWrapDiv>
      </TextBoxArea>

      <ButtonWrapDiv className="btn_bottom">
        <FunctionButton
          className="big"
          value={t("L0355")}
          onClick={handleNext}
        ></FunctionButton>
      </ButtonWrapDiv>

      {isDialogOpen && (
        <MessageDialog title={"Information"} message={dialogMsg}>
          <FunctionButton
            value={t("L0004")}
            onClick={handleConfirm}
          ></FunctionButton>
        </MessageDialog>
      )}
    </div>
  );
};

export default RegWaCheckPage;
